import {
  isSchemaCapableProvider,
  schemaCapableServices,
} from "@/utils/schemaServices";
import {
  parseResourceId,
  parseSchemaRowId,
  SCHEMA_EDITOR_ID,
} from "./stagingModel";

// Where a block's NEW schema is saved (TTTL-319). Schemas live per
// service — every MongoDB and Pub/Sub service has a store of its own — so
// a schema written in a stage's block goes to that stage's service when it
// can store schemas (the natural home of a schema shaped after its own
// collection), and otherwise, as for the tab's unattached bottom block, to
// the first schema-capable service in the list.

/** The schema-capable service a block's new schema saves into, or null
 *  while the services list is unknown or holds no such service. */
export function schemaHomeService(
  editorRowId: string,
  services: ReadonlyArray<{ name: string; provider: string }> | undefined,
): string | null {
  const stageId = editorRowId.startsWith(`${SCHEMA_EDITOR_ID}:`)
    ? editorRowId.slice(SCHEMA_EDITOR_ID.length + 1)
    : null;
  const stageService = stageId ? parseResourceId(stageId)?.serviceName : null;
  const own = services?.find((s) => s.name === stageService);
  if (own && isSchemaCapableProvider(own.provider)) return own.name;
  return schemaCapableServices(services)[0]?.name ?? null;
}

/** The service a staged row's "Save as" fork saves into: the fork stays in
 *  the folder the schema came from — the service its row id names — only
 *  under the new name. Null for a row that is not a stored schema. */
export function schemaForkService(sourceRowId: string): string | null {
  return parseSchemaRowId(sourceRowId)?.serviceName ?? null;
}
